(function () {
  const POPUP_ID = "promo-feira-bebe-2026";                 // mete aqui o Id do teu popup
  const TARGET_URL = "https://www.eupoupo.com/pages/feira-do-bebe-2026";    // muda para o URL desejado

  function getClickableImage(popupEl) {
    // escolhe a primeira imagem que NÃO esteja dentro de um form
    const imgs = Array.from(popupEl.querySelectorAll("https://cdn.shopify.com/s/files/1/0743/8824/2710/files/Dodot___Slider_2.jpg?v=1770045422"));
    return imgs.find(img => !img.closest("form")) || null;
  }

  function hook() {
    const popup = document.getElementById(POPUP_ID);
    if (!popup) return false;

    const img = getClickableImage(popup);
    if (!img) return false;

    if (img.dataset.popupLinked === "1") return true;
    img.dataset.popupLinked = "1";

    img.style.cursor = "pointer";
    img.addEventListener("click", function () {
      window.location.href = TARGET_URL; // ou window.open(TARGET_URL, "_blank")
    });

    return true;
  }

  if (hook()) return;

  const obs = new MutationObserver(() => {
    if (hook()) obs.disconnect();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
